import _extends from "@babel/runtime/helpers/extends";
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/** @jsxFrag */
import React from 'react';
import { LinkItem } from '@atlaskit/menu';
import { RenderTracker, SWITCHER_ITEM_LOZENGES_SUBJECT } from '../../common/utils/analytics';
import { FadeIn } from './fade-in';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import Lozenge from '@atlaskit/lozenge';
import { FormattedMessage } from 'react-intl-next';
import messages from './messages';
import ErrorBoundary from '../components/error-boundary';
export let LozengeType = /*#__PURE__*/function (LozengeType) {
  LozengeType["New"] = "new";
  LozengeType["Try"] = "try";
  return LozengeType;
}({});
const lozengeData = {
  [LozengeType.New]: {
    label: messages.newLozenge,
    componentProps: {
      appearance: 'new'
    }
  },
  [LozengeType.Try]: {
    label: messages.tryLozenge,
    componentProps: {
      appearance: 'new'
    }
  }
};
const fadeInStyles = css({
  width: '100%'
});

// this marginTop -4px is to avoid the bottom of description text get cut off
const itemDescriptionStyles = css({
  marginTop: `${"var(--ds-space-negative-050, -4px)"}`,
  display: 'block'
});
const SwitcherItem = ({
  icon,
  description,
  elemAfter,
  shouldAllowMultiline,
  onClick,
  children,
  lozenges,
  product,
  createAnalyticsEvent,
  tag,
  href,
  ...rest
}) => {
  const itemDescription = React.useMemo(() => {
    if ( /*#__PURE__*/React.isValidElement(description) || typeof description === 'string') {
      return jsx("span", {
        css: itemDescriptionStyles
      }, description);
    }
    return undefined;
  }, [description]);
  const renderLozenges = React.useMemo(() => {
    if (!(lozenges !== null && lozenges !== void 0 && lozenges.length)) {
      return null;
    }
    return jsx(ErrorBoundary, {
      product: product,
      triggerSubject: "switcherItemLozengeErrorBoundary",
      hideFallbackUI: true
    }, jsx(React.Fragment, null, lozenges.map((lozenge, index) => {
      const {
        componentProps,
        label
      } = lozengeData[lozenge];
      return jsx("span", {
        key: index
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        ,
        style: {
          marginLeft: "var(--ds-space-100, 8px)"
        }
      }, jsx(Lozenge, _extends({}, componentProps, {
        testId: "switcher-item-lozenge"
      }), jsx(FormattedMessage, label)));
    }), jsx(RenderTracker, {
      subject: SWITCHER_ITEM_LOZENGES_SUBJECT,
      data: {
        product,
        lozenges,
        children,
        description
      }
    })));
  }, [lozenges, product, children, description]);
  return jsx(FadeIn, {
    css: fadeInStyles,
    tag: tag
  }, jsx(LinkItem, _extends({
    testId: "switcher-base-item",
    description: itemDescription,
    iconBefore: icon,
    shouldTitleWrap: false,
    shouldDescriptionWrap: false,
    iconAfter: elemAfter,
    target: "_blank",
    href: href !== null && href !== void 0 ? href : '#',
    onClick: event => {
      // To prevent the page from reloading when using a fallback '#' in href, make sure to use preventDefault.
      if (!href) {
        event.preventDefault();
      }
      if (onClick) {
        onClick(event);
      }
    }
  }, rest), children, renderLozenges));
};
export default SwitcherItem;